<span class="ja" [ngClass]="'ja-' + size" role="img" [attr.aria-label]="'repuestos.agent.avatarAlt' | transloco">
  <span class="ja-dot" *ngIf="statusDot"></span>
</span>
